import AuthorizationTransactionRow from './AuthorizationTransactionRow';

export default AuthorizationTransactionRow;
